const viewer = document.querySelector('model-viewer');
const status = document.querySelector('.status');
viewer.setAttribute('auto-rotate', '');
viewer.setAttribute('auto-rotate-delay', '0');
viewer.setAttribute('rotation-per-second', '6deg');
let ready = false;
viewer.addEventListener('progress', (event) => {
  if (ready) return;
  const progress = Math.round(event.detail.totalProgress * 100);
  status.textContent = progress < 100 ? `Loading 3D figure - ${progress}%` : 'Preparing 3D figure...';
});
viewer.addEventListener('load', () => {
  ready = true;
  status.textContent = 'Drag to rotate / Pinch or scroll to zoom';
});
viewer.addEventListener('error', () => {
  status.textContent = 'This 3D figure could not load. Please reload the page.';
});
import('./model-viewer.min.js').catch(() => {
  status.textContent = 'The 3D viewer could not start. Please reload in a current browser.';
});
